export enum LocalStorageKey {
    accessToken = 'accessToken',
    theme = 'theme',
}
